module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UPYNzM/tc-custom/9780369713452.jpg?1743861623487",
      "alt": "This image is the cover for the book Bahamas Escape with the Best Man"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bahamas Escape with the Best Man\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" Escape to the Bahamas in this whirlwind romance by Cara Colter for Harlequin Romance."), _c('br'), _c('br'), _c('b', [_vm._v("Could losing their inhibitions…")]), _c('br'), _c('br'), _c('i', [_vm._v("…lead to losing their hearts?")]), _c('br'), _c('br'), _vm._v(" Marlee Copeland is the bridesmaid who hates weddings after being left at the altar. Billionaire Matteo Keller is the best man who avoids love after a devastating loss. Brought together in the Bahamas for the wedding, they find themselves letting go and giving in to their unexpected, thrilling chemistry. But when the \"I dos\" have been said and their different worlds beckon, will the magic of the island make going their separate ways impossible?"), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Romance: ")]), _c('b', [_c('i', [_vm._v("Be swept away by glamorous and heartfelt love stories.")])])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cara Colter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cara Colter shares ten acres in British Columbia with her real life hero Rob, ten horses, a dog and a cat.  She has three grown children and a grandson. Cara is a recipient of the Career Acheivement Award in the Love and Laughter category from Romantic Times BOOKreviews.  Cara invites you to visit her on Facebook!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0